// // src/components/views/LeadershipView.jsx
import { useState, useMemo } from "react";
import DepartmentAccordion from "../common/DepartmentAccordion";

const LeadershipView = ({ data = {} }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const departments = data.departments || [];

  const filteredData = useMemo(() => {
    if (!searchTerm) return departments;
    const lowerFilter = searchTerm.toLowerCase();

    return departments
      .map((dept) => {
        const leaders = (dept.leaders || []).filter((leader) => (
          leader.name?.toLowerCase().includes(lowerFilter) ||
          leader.title?.toLowerCase().includes(lowerFilter) ||
          leader.city?.toLowerCase().includes(lowerFilter) ||
          leader.country?.toLowerCase().includes(lowerFilter) ||
          leader.continent?.toLowerCase().includes(lowerFilter) ||
          // --- FIX: Added email to the search filter ---
          leader.email?.toLowerCase().includes(lowerFilter) ||
          leader.Email?.toLowerCase().includes(lowerFilter)
        ));
        return { ...dept, leaders };
      })
      .filter((dept) => dept.leaders.length > 0);
  }, [departments, searchTerm]);

  return (
    <div className="leadership-container">
      <div className="search-header">
        <input
          type="text"
          placeholder="🔍 Search by Name, Title, Location, Email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      {filteredData.length > 0 ? (
        filteredData.map((dept) => <DepartmentAccordion key={dept.name} dept={dept} />)
      ) : (
        <p>No leaders found for "{searchTerm}".</p>
      )}
    </div>
  );
};

export default LeadershipView;